import React from "react";

function AppDown() {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "red",
      }}
    >
      <h1>Application crashed!</h1>
    </div>
  );
}

export default AppDown;
